import React, { useContext } from 'react';

import Spacer from '@helsenorge/designsystem-react/components/Spacer';

import LanguageLocales from '@helsenorge/core-utils/constants/languages';
import { safeFormatCET, DateFormat, loadLocale } from '@helsenorge/core-utils/date-fns-utils';
import { getAssetsUrl } from '@helsenorge/framework-utils/hn-page';
import { getErInnloggetViaHnAppUngdom } from '@helsenorge/framework-utils/hn-user';
import WebCompConsumer from '@helsenorge/framework-utils/web-component/consumer';

import { globalStateContext } from '../../store';
import LogoutButton from '../logout-button';

import styles from './styles.module.scss';

const transformLastLogonFormat = (time: string, locale?: LanguageLocales): string => {
  if (locale === LanguageLocales.NORWEGIAN_NYNORSK || locale === LanguageLocales.ENGLISH || locale === LanguageLocales.SAMI_NORTHERN) {
    loadLocale(locale);
  } else {
    loadLocale(LanguageLocales.NORWEGIAN);
  }

  return safeFormatCET(time, DateFormat.LongDateTime);
};

const MenuProfile: React.FC = () => {
  const globalState = useContext(globalStateContext);

  const renderSistInnlogget = (): React.JSX.Element | undefined => {
    if (globalState.bruker?.sistInnlogget) {
      return (
        <p className={styles.sistinnlogget}>
          {globalState.headerFooter.header.profileMenu.headerMenuProfileSistInnlogget}{' '}
          {transformLastLogonFormat(globalState.bruker?.sistInnlogget, globalState.language)}
        </p>
      );
    }
  };

  if (getErInnloggetViaHnAppUngdom()) {
    return (
      <div data-testid="menu-profile">
        <LogoutButton />
        <Spacer size={'m'} />
        {renderSistInnlogget()}
      </div>
    );
  }

  const personvelger = (
    <WebCompConsumer
      domain={`${getAssetsUrl()}/personvelgeren`}
      entryName="src/index.tsx"
      componentName="hn-webcomp-personvelger-component"
      templateName="hn-webcomp-personvelger-template"
      includeHelsenorgeCss
      componentProps={{
        redirecturl: globalState.personvelgerRedirectUrl,
      }}
    />
  );

  return (
    <div className={styles['menu-profile']} data-testid="menu-profile">
      {personvelger}
      <div>
        {globalState.bruker?.sistInnlogget && renderSistInnlogget()}
        <LogoutButton />
      </div>
    </div>
  );
};

export default MenuProfile;
